
import { Message } from 'element-ui';
import { post } from './api'

export class Auth {
  loading: boolean = false
  isImg: boolean = false
  imgSt: string = ''
  self = this
  goLogin(user: any, router: any) {
    this.loading = true
    post('/back/v1/usr/login', user)
      .then(d => {
        // console.log(d)
        Message({
          message: '登录成功',
          type: 'success',
          duration: 5 * 1000
        })
        this.loading = false
        // @ts-ignore
        sessionStorage.setItem('MENU', JSON.stringify(d['Content']['menu']))
        // @ts-ignore
        sessionStorage.setItem('user_name', d['Content']['nick_name'])
        router.push('/home')
      })
      .catch(e => {
        this.loading = false
        console.log(e)
        // console.log(e.data)
        if (e.Code === 201) {
          this.isImg = true
          this.imgSt = e.Content.qr_code
        }
      })
  }
}
